module.exports = __webpack_public_path__ + "img/kg.7be03cee.svg";